import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { driversService } from '../../../services/driversService';
import { DriverShortDto } from '../../../models/drivers/driverShortDto';

interface DriversAutocompleteFormControlProps {
  name: string;
  companyId: number | null;
  medicalcheckupId?: number;
  label?: string;
  style?: React.CSSProperties;
  required?: boolean;
}

const DriversAutocompleteFormControl: React.FC<DriversAutocompleteFormControlProps> = ({ name, companyId, medicalcheckupId, label = 'Сотрудники', style, required }) => {
  const { control, setValue } = useFormContext();
  const [options, setOptions] = useState<DriverShortDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (companyId) {
      setLoading(true);
      const filter: any = {
        companyId,
        page: 0,
        pageSize: 1000,
        hideDismissed: true,
        employeeNumber: null,
        fio: null,
      };
      if (medicalcheckupId) {
        filter.medicalcheckupId = medicalcheckupId;
      }
      driversService.getByFilter(filter)
        .then(r => setOptions(r.data.data.items))
        .catch(() => setOptions([]))
        .finally(() => setLoading(false));
      setValue(name, []); // Reset drivers on companyId/medicalcheckupId change
    } else {
      setOptions([]);
      setValue(name, []);
    }
  }, [companyId, medicalcheckupId, name, setValue]);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? 'Обязательное поле' : false }}
      render={({ field, fieldState }) => (
        <Autocomplete
          multiple
          options={options}
          getOptionLabel={option => `${option.lastName} ${option.firstName} ${option.middleName}`}
          value={field.value}
          onChange={(_, value) => field.onChange(value)}
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              margin="dense"
              size="small"
              style={style}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              required={required}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          size="small"
          disabled={!companyId}
        />
      )}
    />
  );
};

export default DriversAutocompleteFormControl; 